import React, { PureComponent } from 'react'
import classNames from 'classnames'
import { withStyles } from 'material-ui-next/styles'
import Icon from 'material-ui-next/Icon'

import { themeColors } from '../styles/theme'

const styles = theme => ({
  wantedHeart: {
    fontSize: 30,
    color: theme.swapick.colors.positive,
    '&.loading': {
      pointerEvents: 'none',
      opacity: '0.4',
    },
  },
})

class WantedHeart extends PureComponent {
  hanldeIWantNot = e => {
    e.preventDefault()
    e.stopPropagation()
    this.props.iWantNot()
  }

  hanldeIWant = e => {
    e.preventDefault()
    e.stopPropagation()
    this.props.iWant()
  }

  render() {
    const { wanted, loading, classes } = this.props

    if (wanted) {
      return (
        <Icon
          className={classNames(classes.wantedHeart, { loading })}
          onClick={this.hanldeIWantNot}>
          favorite
        </Icon>
      )
    } else {
      return (
        <Icon
          className={classNames(classes.wantedHeart, { loading })}
          onClick={this.hanldeIWant}>
          favorite_border
        </Icon>
      )
    }
  }
}

export default withStyles(styles)(WantedHeart)



// WEBPACK FOOTER //
// ./src/common/WantedHeart.js